"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowNumberInputError = void 0;
exports.parseWorkflowNumber = parseWorkflowNumber;
exports.decodeNumberInputError = decodeNumberInputError;
/** Deterministic input parsing. Display language never selects a number format. */
function parseWorkflowNumber(raw, decimalComma) {
    if (raw == null)
        return { ok: true, value: null };
    if (typeof raw === 'number')
        return Number.isFinite(raw) ? { ok: true, value: raw } : { ok: false };
    if (typeof raw === 'boolean')
        return { ok: true, value: raw ? 1 : 0 };
    if (typeof raw !== 'string')
        return { ok: false };
    const text = raw.trim();
    if (!text)
        return { ok: true, value: null };
    // Grouping is optional, but if present each group must contain three digits.
    const pattern = decimalComma
        ? /^[+-]?(?:\d+|\d{1,3}(?:\.\d{3})+)(?:,\d+)?(?:e[+-]?\d+)?$/i
        : /^[+-]?(?:\d+|\d{1,3}(?:,\d{3})+)(?:\.\d+)?(?:e[+-]?\d+)?$/i;
    if (!pattern.test(text))
        return { ok: false };
    const normalized = decimalComma
        ? text.replaceAll('.', '').replace(',', '.')
        : text.replaceAll(',', '');
    const value = Number(normalized);
    return Number.isFinite(value) ? { ok: true, value } : { ok: false };
}
const NUMBER_INPUT_ERROR_PREFIX = 'AUTOMATION_NUMBER_FORMAT:';
/** Stable, value-free error payload; UI translates it using the viewer's language. */
class WorkflowNumberInputError extends Error {
    constructor(rowId, fieldName, decimalComma) {
        super(NUMBER_INPUT_ERROR_PREFIX +
            JSON.stringify({ rowId, fieldName, decimalComma }));
        this.name = 'WorkflowNumberInputError';
    }
}
exports.WorkflowNumberInputError = WorkflowNumberInputError;
function decodeNumberInputError(message) {
    const start = message.indexOf(NUMBER_INPUT_ERROR_PREFIX);
    if (start < 0)
        return null;
    try {
        const details = JSON.parse(message.slice(start + NUMBER_INPUT_ERROR_PREFIX.length));
        if (!details || typeof details !== 'object')
            return null;
        const value = details;
        if (typeof value.rowId !== 'string' ||
            typeof value.fieldName !== 'string' ||
            typeof value.decimalComma !== 'boolean')
            return null;
        return {
            rowId: value.rowId,
            fieldName: value.fieldName,
            decimalComma: value.decimalComma,
        };
    }
    catch {
        return null;
    }
}
